import {TypeaheadDRF, useStore} from '@/core'
import {doc} from './doc'
import {types} from './types'

export const TypeaheadPurposely = doc(
  ({type, ...props}) => {
    const store = useStore()
    return <TypeaheadDRF {...props} {...types[type](store)} />
  }
)
